import { VSelect } from 'vuetify/lib/components/VSelect';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VSelect,_vm._b({attrs:{"outlined":"","dense":"","label":_vm.$t('Rows per page'),"item-text":"text","item-value":"value","items":_vm.items,"hide-details":"auto"},model:{value:(_vm.perPage),callback:function ($$v) {_vm.perPage=$$v},expression:"perPage"}},'v-select',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }